import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLINVERTEDHAMMER', label: 'Inverted Hammer', lookback: 11 })
